import { Helmet } from "react-helmet"

export const HelmetComponent = ({title}) => <Helmet><title>AIO {title ? `| ${title}` : ''}</title> </Helmet>;